import { useForm } from './form'

export function useFormInput(inputElement) {
  const formId = inputElement.getAttribute('form')
  const formElement = formId ? document.getElementById(formId) : inputElement.closest('form')
  const form = useForm(formElement)

  // Get all the dependencies that belong to this input
  const dependencies = form.dependencies?.filter(dep => dep.matches(inputElement)) || []

  // Use to configure a this input to listen to all dependent changes. This will trigger a change
  // for every type of dependency - e.g changing values, options, etc.
  const onDependentChange = listener => {
    dependencies.forEach(dep => {
      dep.subscribeToFormUpdates(() => listener(dep))
    })
  }

  return { onDependentChange, dependencies, form, formElement }
}
